import { makeStyles, Theme } from '@material-ui/core/styles';

const drawerWidth = 100;
const tablePadding = 35;

 export default makeStyles((theme: Theme) => ({
     paper:{
        marginTop:'20px',
        paddingTop: '25px',
        paddingLeft: '35px',
        paddingRight: '35px',      
        paddingBottom: '25px',   
        width: `calc(100vw - ${drawerWidth + (tablePadding * 2)}px) !important`
     },
     button:{
         color:'white',
         backgroundColor:'#107A98',
         marginLeft:'40px',
          '&:hover': {
              backgroundColor: '#004763!important',
          },
         position:'absolute',
         bottom:'0px',
         right:'0px',         
     },    
     buttonsContainer:{
        display:'flex',
        alignItems:'center',
        justifyContent:'flex-end',
        width:'100%',
        height:'100%',
    },
     gridContainer:{
         position:'relative',
         marginBottom:'20px',
         paddingBottom:'60px',
         paddingTop:'20px',
         paddingLeft: '30px',
         paddingRight: '30px',
     },
     tableContainer:{
         paddingBottom:'80px'
     },    
     selectInput: {
       width:'100%',
     },
     selectDropdown: {
        width:'200px',       
        },
     paperTitle: {
        color: '#428302',
        marginBottom:'25px',
        fontSize: '16px',
    },
 })); 